import React, { useState } from 'react';

const LoginForm = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false); // Estado para mostrar/ocultar contraseña
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    onLogin(email, password)
      .catch(() => {
        setError('Email o contraseña incorrectos.');
      });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 bg-white p-10 rounded-lg shadow-md">
        <div>
          <img
            className="mx-auto h-16 w-auto"
            src="https://4tsix0yujj.ufs.sh/f/2vMRHqOYUHc0ruupdRNQiYtyo2GFJjxB80HOpNwcWZhvnAD4"
            alt="Doctorweb Logo"
          />
          <h1 className="mt-6 text-center text-3xl font-extrabold text-[#0061A8]">
            Expediente Doctorweb
          </h1>
          <h2 className="mt-2 text-center text-2xl font-bold text-[#0061A8]">
            Inicia Sesión
          </h2>
          <p className="mt-2 text-center text-sm text-[#63666A]">
            Hoy es tu oportunidad para ayudar a los clientes a crecer.
          </p>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="email-address" className="sr-only">
                Email
              </label>
              <input
                id="email-address"
                name="email"
                type="email"
                autoComplete="email"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-[#D1D3D4] placeholder-[#63666A] text-[#0061A8] rounded-t-md focus:outline-none focus:ring-[#0061A8] focus:border-[#0061A8] focus:z-10 sm:text-sm"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="relative">
              <label htmlFor="password" className="sr-only">
                Contraseña
              </label>
              <input
                id="password"
                name="password"
                type={showPassword ? 'text' : 'password'} // Cambiar tipo según showPassword
                autoComplete="current-password"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-[#D1D3D4] placeholder-[#63666A] text-[#0061A8] rounded-b-md focus:outline-none focus:ring-[#0061A8] focus:border-[#0061A8] focus:z-10 sm:text-sm"
                placeholder="Contraseña"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5 text-[#63666A]"
              >
                {showPassword ? (
                  <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-2.072m8.575 8.575A8.995 8.995 0 0112 18c-2.648 0-5.121-.688-7.42-1.888M15 12a3 3 0 11-6 0 3 3 0 016 0zm-4 0a1 1 0 102 0 1 1 0 00-2 0zm4 8a2 2 0 100-4 2 2 0 000 4z"/>
                  </svg>
                ) : (
                  <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                  </svg>
                )}
              </button>
            </div>
          </div>

          {error && (
            <p className="text-red-500 text-sm text-center">{error}</p>
          )}

          <div>
            <button
              type="submit"
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-[#FFFFFF] bg-[#0061A8] hover:bg-opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#0061A8]"
            >
              Iniciar Sesión
            </button>
          </div>
        </form>
        <div className="mt-6 text-center text-xs text-[#63666A]">
          <p>
            Al iniciar sesión, aceptas nuestro{' '}
            <a href="#" className="font-medium text-[#0061A8] hover:text-[#A8D08D]">
              Aviso de Privacidad
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;